import { FSetupGraph } from '@spazious/dollhouse-fsetup';

/**
 * Get the furniture stats from the graph
 */
export const getFurnitureStats = (graph: FSetupGraph) => {
  const furnitureStats: { [key: number]: number } = {};

  graph.traverse((node) => {
    if (node.type === 'furniture' && node.id) {
      furnitureStats[node.id] = (furnitureStats[node.id] ?? 0) + 1;
    }
  });

  return Object.entries(furnitureStats).map(([key, value]) => ({
    furniture: Number(key),
    count: value,
  }));
};
